import React, { ReactNode } from 'react';
import { LayoutInternal } from '@/layout';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import { Title, TitleFeatured } from '@/components/typography';
import { Grid } from '@/components/grid';
import { Sticky } from '@/components/sticky';
import { useHoneyMoonContext } from '@/features/viagens/HoneyMoon/context';
import SideNavMenu from '@/features/viagens/HoneyMoon/components/SideNavMenu/SideNavMenu';
import { DestinationHeader } from '@/features/viagens/HoneyMoon/HoneyMoon.styles';
import FilterHoneyMoonList from '@/features/pacote/components/FilterHoneyMoonList/FilterHoneyMoonList';
import ProductList from '@/features/pacote/components/ProductList/ProductList';
import CardEbook from '@/features/viagens/HoneyMoon/components/CardEbook/CardEbook';
import CardCurrencyInfo from '@/features/pacote/components/CardCurrencyInfo/CardCurrencyInfo';

export interface ViagensListProps {
  children?: ReactNode;
}

const HoneyMoon = ({ children, ...props }: ViagensListProps) => {
  const { data } = useHoneyMoonContext();
  const { travelType, pacotes, listDestinos } = data;
  const breadcrumbs: BreadcrumbType = [{ path: '/viagens', text: 'Viagens' }, { text: 'Lua de Mel' }];

  return (
    <LayoutInternal breadcrumbs={breadcrumbs} cover={travelType.cover}>
      <WhitePaper col={12}>
        <TitleFeatured as="h1" title={travelType.title} description={travelType.description} />
      </WhitePaper>

      <Grid item col={12} col-sm={12} col-lg={3} as="aside">
        <Sticky top={5}>
          <SideNavMenu />
          <WhitePaper visibility={{ hide: 'sm' }}>
            <CardEbook />
          </WhitePaper>
        </Sticky>
      </Grid>

      <Grid item col={12} col-sm={12} col-lg={9}>
        <WhitePaper>
          <FilterHoneyMoonList initialData={pacotes} listDestinos={listDestinos as unknown as ListDestinosType[]}>
            {({ data }) => (
              <>
                {data.map(({ continent, pacotes }) => {
                  let id = continent.toLowerCase();
                  return (
                    <div id={id} key={`${continent}-${id}`}>
                      <Sticky top={0} zIndex={10} bgColor="white">
                        <DestinationHeader>
                          <Title as="h3" weight="black" textCase="uppercase" color="primary_500">
                            Roteiros Lua de Mel
                          </Title>
                          <Title as="h3" size="xl" weight="black" textCase="uppercase" color="primary_500">
                            {continent}
                          </Title>
                        </DestinationHeader>
                      </Sticky>
                      <ProductList pacotes={pacotes} />
                    </div>
                  );
                })}
              </>
            )}
          </FilterHoneyMoonList>
        </WhitePaper>
        <CardCurrencyInfo />
        <WhitePaper visibility={{ min: 'sm' }}>
          <CardEbook />
        </WhitePaper>
      </Grid>
    </LayoutInternal>
  );
};

export default HoneyMoon;
